import {Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  UntypedFormControl,
  UntypedFormGroup, ValidationErrors,
  Validators
} from "@angular/forms";
import {Subscription} from "rxjs";
import {pairwise, startWith} from "rxjs/operators";
import { NotOnlySpaces } from '../../../shared/CustomValidators/CustomNotOnlySpacesValidator';
import { EmailValidator } from '../../../shared/CustomValidators/CustomInvalidEmailValidator';
import {WebsiteURLValidator} from '../../../shared/CustomValidators/CustomWebsiteUrlValidator';
import {PhoneNumberValidator} from '../../../shared/CustomValidators/CustomInvalidPhoneNumberValidator';
@Component({
    selector: 'app-job-site-name',
    templateUrl: './job-site-name.component.html',
    styleUrls: ['./job-site-name.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => JobSiteNameComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => JobSiteNameComponent),
            multi: true
        }
    ],
    standalone: false
})
export class JobSiteNameComponent implements OnInit {
  @Input() isEdit: boolean = false;
  @Input() defaultTitle: string = '';
  @Input() form: any = {};
  @Input() model: any = {};
  @Output() callback = new EventEmitter<any>(true);
  @Output() onInitForm = new EventEmitter<any>(true);
  public onModelValueChanged:any = {};
  // @ts-ignore
  private warehouseSubscription: Subscription;

  public warehouse: UntypedFormGroup = this.initFormWarehouse();

  constructor() { }


  ngOnChanges(changes: SimpleChanges) {
    this.model = changes?.model?.currentValue;
    // this.onModelValueChanged = this.model.model;
    console.log('addNewJobSite 3', this.defaultTitle);
    if(this.defaultTitle) {
      this.warehouse.get('name')?.setValue(this.defaultTitle);
    }

  }

  ngOnInit(): void {
    this.initSubscriptions();
    console.log('ngOnInit model', this.model);
    this.initForm(this.model.model);
  }

  ngAfterViewInit() {
    this.setDataOnEdit();
  }
  initForm(value: any = null){
    this.warehouse = this.initFormWarehouse(value);
    this.onInitForm.emit( this.warehouse);
  }
  initFormWarehouse(value: any = null){
    return new UntypedFormGroup({
      name: new UntypedFormControl(value?.name ? value.name : this.defaultTitle,[Validators.required,NotOnlySpaces()]),
      email: new UntypedFormControl(value?.email,[EmailValidator()]),
      phone: new UntypedFormControl(value? value.phone : '',[PhoneNumberValidator()]),
      fax: new UntypedFormControl(value?.fax)
    });
    this.onInitForm.emit(this.warehouse);
    return this.warehouse;
  }

  setDataOnEdit() {
    if(this.isEdit) {
      this.warehouse?.setValue({
        name: this.model?.title,
        email: this.model?.email,
        phone: this.model?.phone,
        fax: this.model?.phone
      })
    }
  }

  touchFormControls(){
    Object.keys(this.warehouse.controls).forEach(key => {
      this.warehouse.get(key)?.markAsTouched();
    });
  }
  public onTouched: () => void = () => {};

  writeValue(val: any): void {
    val && this.warehouse.setValue(val, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.warehouse.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.warehouse.disable() : this.warehouse.enable();
  }

  validate(c: AbstractControl): ValidationErrors | null{
    return this.warehouse.valid ? null : { invalidForm: {valid: false, message: "warehouse  fields are invalid"}};
  }
  initSubscriptions(){
    // @ts-ignore
    this.warehouse.get('name').updateValueAndValidity({ onlySelf: false, emitEvent: true });
    this.warehouseSubscription = this.form.get('step01').valueChanges
      .pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        if (this.form.get('step01').touched){
          this.touchFormControls();
        }
      });
  }

  ngOnDestroy(){
    // prevent memory leak when component destroyed
    this.warehouseSubscription.unsubscribe();
  }
}
